/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Bank_AccountInputs */

const vi_invoice_bank_account = /** @type {(inputs: Invoice_Bank_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tài khoản`)
};

/**

* @param {Invoice_Bank_AccountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_bank_account = /** @type {((inputs?: Invoice_Bank_AccountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Bank_AccountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_bank_account(inputs)
});